import React from 'react';
import HeaderMenu from '../components/HeaderMenu';
import TabMenu from '../components/TabMenu';
import Footer from '../components/Footer';

const Master = () => {
  return (
    <>
    <HeaderMenu />
    <TabMenu />
    <Footer />
      
    </>
  )
}

export default Master;
